import { render, staticRenderFns } from "./Box17.vue?vue&type=template&id=7ccceaec&scoped=true&"
import script from "./Box17.vue?vue&type=script&lang=js&"
export * from "./Box17.vue?vue&type=script&lang=js&"
import style0 from "./Box17.vue?vue&type=style&index=0&id=7ccceaec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccceaec",
  null
  
)

export default component.exports